// extracted by mini-css-extract-plugin
export default {"cls1":"SignupBanner-cls1_qs2","cls2":"SignupBanner-cls2_HAe SignupBanner-cls1_qs2"};